"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _semanticUiReact = require("semantic-ui-react");
var _default = function _default(props) {
  var showLabels = props.showLabels,
    field = props.field,
    value = props.value,
    error = props.error,
    onChange = props.onChange,
    disabled = props.disabled;
  var label = field.label,
    placeholder = field.placeholder,
    type = field.type,
    required = field.required,
    options = field.options,
    inputType = field.inputType;
  var labelToDisplay = showLabels ? label.slice(0, 1).toUpperCase() + label.slice(1) : '';
  if (type === 'hidden') {
    // No UI element.
    return null;
  }
  if (type === 'select') {
    var updatedOptions = options.map(function (option) {
      return {
        key: option.value,
        value: option.value,
        text: option.label
      };
    });
    return /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Form.Select, {
      disabled: disabled,
      error: error,
      required: required,
      key: label,
      name: label,
      label: labelToDisplay,
      placeholder: placeholder,
      value: value,
      labeled: false,
      options: updatedOptions,
      onChange: onChange
    });
  }
  return /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Form.Field, {
    disabled: disabled,
    error: error,
    required: required,
    key: label,
    name: label,
    label: labelToDisplay,
    placeholder: placeholder,
    control: type === 'input' ? _semanticUiReact.Input : _semanticUiReact.TextArea,
    value: value,
    onChange: onChange,
    type: inputType || 'text'
  });
};
exports["default"] = _default;